import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchDomain, FetchDomainParams } from 'features/domains/api'
import { HOME_JOB_REDUCER_NAME } from 'features/home/consts'

const homeJobSlice = makeFetchSlice(HOME_JOB_REDUCER_NAME)
export const homeJobReducer = homeJobSlice.reducer
export const homeJobActions = homeJobSlice.actions

export const fetchHomeJobThunk = (
  domainId: string,
  params?: FetchDomainParams
) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: homeJobActions,
        asyncFunc: () => fetchDomain(domainId, params),
      })
    } catch (error) {
      console.log('Error fetching home job', error)
    }
  }
}
